import { config, appFetch } from "../appFetch";

export const getSessions = (cinema, uuid, film, onSuccess, onErrors) => appFetch(`https://api.galicine.com.es/api/pelicula/function::getSesiones||cine::${cinema}||uuid::${uuid}||pelicula::${film}`, config("GET"), onSuccess, onErrors);
